// pages/admin/PlayerReport.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import Navbar from '../../components/Navbar';

export default function PlayerReport() {
  const { id } = useParams();
  const [player, setPlayer] = useState(null);

  useEffect(() => {
    const fetchPlayer = async () => {
      const ref = doc(db, 'users', id);
      const snap = await getDoc(ref);
      let data = snap.exists() ? snap.data() : {};

      const lbRef = doc(db, 'leaderboard_master', id);
      const lbSnap = await getDoc(lbRef);
      if (lbSnap.exists()) {
        data = { ...data, ...lbSnap.data() };
      }

      setPlayer(data);
      }

    fetchPlayer();
  }, [id]);

  if (!player) return <div className="p-6 text-center text-gray-600">Loading player report...</div>;

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-white px-6 py-10">
        <h1 className="text-2xl font-bold text-purple-700 mb-4">📄 Player Report</h1>
        <div className="bg-purple-50 p-6 rounded-lg shadow-md space-y-4">
          <div><strong>Name:</strong> {player.name || '—'}</div>
          <div><strong>Email:</strong> {player.email || '—'}</div>
          <div><strong>Referrer:</strong> {player.referrerName || '—'}</div>
          <div><strong>Access:</strong> {player.accessType}</div>
          <div><strong>Expiry:</strong> {player.accessExpiry || '—'}</div>
          <div><strong>Chronos:</strong> {player.chronos ?? 0}</div>
          
          <div><strong>Best Focus Streak:</strong> {player.bestFocusGameStreak ?? '-'}</div>
          <div><strong>Best Number Memory:</strong> {player.bestNumberMemoryLevel ?? '-'}</div>
          <div><strong>Best Synonym Sync:</strong> {player.bestSynonymWords ?? '-'}</div>
          <div><strong>Best Math Sprint:</strong> {player.bestMathSprintScore ?? '-'}</div>
          <div><strong>Best Logic Score:</strong> {player.bestLogicScore ?? '-'}</div>
        </div>
      </div>
    </>
  );
}
